import { render } from "./TestInstructionsStepSix.vue?vue&type=template&id=56190356&scoped=true&ts=true"
import script from "./TestInstructionsStepSix.vue?vue&type=script&lang=ts"
export * from "./TestInstructionsStepSix.vue?vue&type=script&lang=ts"

import "./TestInstructionsStepSix.vue?vue&type=style&index=0&id=56190356&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56190356"]])

export default __exports__